"use client"

import DomainForm from "@/components/DomainForm";
import { DomainFormSchema } from "@/schemas/domain-form.schema";
import { useState } from "react";
import { z } from "zod";


export default function CreateDomainPage() {

    const [isLoading, setIsLoading] = useState(false);

    const handleOnSubmit = async (data: z.infer<typeof DomainFormSchema>) => {
        try {
            console.log(data);
            setIsLoading(true);
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    }

    return (
        <DomainForm companyId={'123'} onSubmit={handleOnSubmit} isLoading={isLoading} className="max-h-150 w-full" />
    )
}